/* ============================================
   FLAVOR THEME — Cart Drawer
   Handles AJAX cart operations
   ============================================ */

(function () {
  'use strict';

  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  /* --- Update cart drawer via Section Rendering API --- */
  Flavor.updateCartDrawer = function () {
    return fetch(Flavor.routes.cart_url + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CartDrawer');
        if (fresh) {
          var wasOpen = drawer.getAttribute('aria-hidden') === 'false';
          drawer.innerHTML = fresh.innerHTML;
          if (wasOpen) drawer.setAttribute('aria-hidden', 'false');
        }

        /* Update header count */
        var countEl = doc.querySelector('[data-cart-count]');
        if (countEl) {
          Flavor.updateCartCount(parseInt(countEl.textContent, 10) || 0);
        }
      });
  };

  /* --- Quantity change --- */
  drawer.addEventListener('click', function (e) {
    var item = e.target.closest('[data-cart-item]');
    if (!item) return;
    var key = item.getAttribute('data-key');
    var qtyEl = item.querySelector('[data-cart-qty-value]');
    var qty = parseInt(qtyEl.textContent, 10);

    if (e.target.closest('[data-cart-qty-minus]')) {
      qty = Math.max(0, qty - 1);
      updateCartItem(key, qty);
    }
    if (e.target.closest('[data-cart-qty-plus]')) {
      qty = qty + 1;
      updateCartItem(key, qty);
    }
    if (e.target.closest('[data-cart-remove]')) {
      updateCartItem(key, 0);
    }
  });

  function updateCartItem(key, quantity) {
    fetch(Flavor.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      Flavor.updateCartDrawer();
    })
    .catch(function (err) { console.error('Cart update error:', err); });
  }

  /* --- Cart note --- */
  var noteDebounce;
  drawer.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cart-note]')) return;
    clearTimeout(noteDebounce);
    noteDebounce = setTimeout(function () {
      fetch(Flavor.routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: e.target.value })
      });
    }, 500);
  });

})();
